var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-component-body"},[_c('i',{staticClass:"close-icon icon-outline_close"})])
}]

export { render, staticRenderFns }